import * as d3_array from 'd3-array'
import * as dayjs from 'dayjs'

export function create_index(data, index_field_accessor, sort_comparator=null, sort_accessor=null) {
    let rollup_fn = sort_comparator ? 
        v => v.sort((a,b) => sort_comparator(sort_accessor(a), sort_accessor(b))) : 
        v => v
    
    return d3_array
        .rollup(
            data,
            rollup_fn,
            index_field_accessor
        )
}

export function last(arr) {
    return arr[arr.length - 1];
}

function lastn(arr, n) {
    return arr.slice(Math.max(arr.length - n, 0))
}


function group_as_array(data, field_name, rows_name="rows") {
    let map = d3_array.group(data, r => r[field_name]);
    return Array.from(map, ([key, rows]) => ({[ field_name ]: key, [ rows_name ]: rows}));
}


export function timeseries(f, config) {
    let dates = config.dates.map(d => d.substring(0, 7))
    let medicines = f.last_r.medicines.map(m => m.medicine);

    let medicine_date_index = new Map(f.reports.map(r => 
        [r.month, d3_array.rollup(r.medicines, v => v.reduce((o,v) => [...o, ...v.rows], []), m => m.medicine)]
    ))

    let res = {};

    medicines.forEach(m =>{
        res[m] = [];
        
        dates.forEach(d => {
            let medicines_for_d = medicine_date_index.get(d);

            let value = null;
            if (medicines_for_d) {
                let rows = medicines_for_d.get(m);
                
                if (rows && rows.length) {
                    value = d3_array.sum(rows, r => +r.unitBalanseEnd || 0)
                }
            }

            res[m].push({
                month: d,
                value: value,
            })
        })
    });
    return res;
}


function reports_by_medicine(f, config) {
    let reports_by_medicine = new Map()
    
    f.reports.forEach(r => {
        r.medicines.forEach(m => {
            let mname = m.medicine;
            
            let val = {month: r.month, usage: d3_array.sum(m.rows, rr => +rr.unitUsed || 0), available: d3_array.sum(m.rows, rr=> +rr.unitBalanseEnd || 0)}

            if (!reports_by_medicine.get(mname)) {
                reports_by_medicine.set(mname, [val])
            } else {
                reports_by_medicine.get(mname).push(val)
            }
        })
    })
    
    return reports_by_medicine
}

function month_to_day(m) {
    return dayjs(m, 'YYYY-MM').endOf('month');
}

function diff_days(d1, d2) { 
    return month_to_day(d2).diff(month_to_day(d1), 'days')
}

export function forecast_expired(f, config) {
    const MIN_REPORTS = 1;
    const MAX_REPORTS = 3;

    // if there is only one report we can't do a forecast
    if (f.reports.length < MIN_REPORTS) {
        return null
    }    
    
    let usage_by_medicine = reports_by_medicine(f, config)
    
    // let timeseries_by_medicine = timeseries(f, config);
    let medicines = f.last_r.medicines;
    
    let forecast = medicines.map(m => {
        let ts = usage_by_medicine.get(m.medicine)

        if (!ts) return null;
        if (ts.length <= MIN_REPORTS) return null;
        
        ts = lastn(ts, MAX_REPORTS)
        // let first_e = ts[0];
        // let last_e = last(ts)

        // let days = diff_days(first_e.month, last_e.month)
        
        let rate = d3_array.mean(ts, r => r.usage)
        let first_to_expire_part = m.rows[d3_array.leastIndex(m.rows, r => r.expirationDate)]
        let last_to_expire_part = m.rows[d3_array.maxIndex(m.rows, r => r.expirationDate)]
        
        let value = d3_array.sum(m.rows, r => +r.unitBalanseEnd || 0);
        let currentDate = month_to_day(first_to_expire_part.month)
        let expirationDate = dayjs(last_to_expire_part.expirationDate, 'YYYY-MM-DD')
        
        let months_to_expiration = Math.ceil(expirationDate.diff(currentDate, 'month', true))
        let months_to_exhaust = Math.ceil(value / rate);

        return {
            medicine: m.medicine,
            rate: rate,
            value: value,
            months_to_exhaust: months_to_exhaust,
            months_to_expiration: months_to_expiration

        };
    })
    
    return forecast.filter(r => r);


    

}



